import { types, Instance, SnapshotOut } from "mobx-state-tree";
import api from "services/api/api";

const Coordinates = types.model("coordinates").props({
  coordinates: types.array(types.number),
});

const AlarmModel = types.model("Alarm").props({
  id: types.maybeNull(types.string),
  height: types.maybeNull(types.number),
  heightWater: types.maybeNull(types.number),
  temperature: types.maybeNull(types.number),
  connectedDate: types.maybeNull(types.string),
  connected: types.maybeNull(types.boolean),
  group: types.maybeNull(types.string),
  address: types.maybeNull(types.string),
  serial: types.maybeNull(types.string),
  location: types.maybeNull(Coordinates),
  // The river service returns this as a boolean, unlike some of the older
  // device services that return a numeric value. Accept both formats so a
  // valid API response cannot prevent the store from completing its load.
  battery: types.maybeNull(types.union(types.boolean, types.number)),
});

const Location = types.model("Location").props({
  lat: types.number,
  lng: types.number,
});

export const LakeAlarmModel = types
  .model("Lake")
  .props({
    alarms: types.optional(types.array(AlarmModel), []),
    locationSelected: types.maybeNull(Location),
    idSelected: types.maybeNull(types.string),
    center: Location,
    isLoading: types.boolean,
  })
  .views((self) => ({
    filterValues(value: string | null) {
      if (value === null) return self.alarms;
      return self.alarms.filter(
        (alarm) =>
          alarm?.id?.toLowerCase().includes(value.toLowerCase()) ||
          alarm?.height?.toString().includes(value.toLowerCase()) ||
          alarm?.group?.toLowerCase().includes(value.toLowerCase())
      );
    },
  }))
  .actions((self) => {
    function setAlarms(alarms: any) {
      self.alarms = alarms;
    }
    function setlocationSelected(cordinates: any) {
      self.locationSelected = cordinates;
    }
    function setId(id: any) {
      self.idSelected = self.idSelected === id ? null : id;
    }
    function setCenter(coordinates: any) {
      self.center = coordinates;
    }
    function setLoading(loading: any) {
      self.isLoading = loading;
    }
    return {
      setAlarms,
      setLoading,
      setCenter,
      setlocationSelected,
      setId,
    };
  })
  .actions((self) => ({
    getDevices: async () => {
      try {
        self.setLoading(true);
        const alarmsApi = api.lake;
        const response = await alarmsApi.getDevice();
        self.setAlarms(response?.devices);
        self.setCenter(response?.center);
      } catch (error) {
        console.log(error);
      } finally {
        // MobX validation or an unexpected API payload must never leave the
        // page permanently blocked by its initial spinner.
        self.setLoading(false);
      }
    },
  }));

type LakeModelType = Instance<typeof LakeAlarmModel>;
export type Lake = LakeModelType;
type LakeSnapshotType = SnapshotOut<typeof LakeAlarmModel>;
export type LakeSnapshot = LakeSnapshotType;
export const lakeDefaultModel = () =>
  types.optional(LakeAlarmModel, {
    alarms: [],
    locationSelected: null,
    idSelected: null,
    center: { lat: 0, lng: 0 },
    isLoading: false,
  });
